import * as React from "react"
import { Modal } from "react-bootstrap"
import { LocationInformationForm } from "./LocationInformationForm"

interface EditLocationInformationProps {
  portalID: number
  companyID: number
  locationID?: number
  adminMode?: boolean
  onCancel: () => void
}

export class EditLocationInformation extends React.PureComponent<EditLocationInformationProps> {
  render() {
    const { companyID, locationID, onCancel, portalID } = this.props

    return <Modal.Dialog size="xl">
      <Modal.Header>
        <Modal.Title className="text-uppercase">Edit Location Information</Modal.Title>
      </Modal.Header>
      <LocationInformationForm adminMode={this.props.adminMode} portalID={portalID} companyID={companyID} locationID={locationID} onCancel={onCancel} add={false}/>
    </Modal.Dialog>
  }
}